import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cea1e232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper_main" }
const _hoisted_2 = { class: "c-modal_inner -is-pickup" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-recommend-form__modal-help-close js-modal-close-trigger",
  type: "button"
}, "閉じる", -1))
const _hoisted_4 = { class: "c-modal_pickup-head" }
const _hoisted_5 = { class: "c-modal_pickup-logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "c-modal_pickup-heading" }
const _hoisted_8 = { class: "c-modal_pickup-body" }
const _hoisted_9 = { class: "c-modal_pickup-image" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "c-modal_pickup-text" }
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "特集ページを見る", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-recommend-button --type-2 js-modal-close-trigger",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "閉じる")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-modal_bg js-modal-close-trigger" }, null, -1))

import { AdvertisementInfo } from '../../types/advertisement';
import { updateAdvertisementBrowsingFlagService } from '../../api/services/advertisementService';

type Props = {
  displogLoginCount: number,
  adsDatas: AdvertisementInfo[]
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertisementView',
  props: {
    displogLoginCount: null,
    adsDatas: null
  },
  setup(__props: any) {

const props = __props as {
  displogLoginCount: number,
  adsDatas: AdvertisementInfo[]
}



function getLogoOrImageSrc(img?: string) {
  if (img) {
    try {
      return `data:image/png;base64,${img}`;
    } catch {
      return require('@/assets/img/video/nonImg.png');
    }
  }
  return require('@/assets/img/video/nonImg.png');
}

const updateAdvertisementBrowsingFlag = async (tGadContractId: number) => {
  await updateAdvertisementBrowsingFlagService(tGadContractId, props.displogLoginCount + 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-modal js-modal-container", {'is-active': __props.adsDatas && __props.adsDatas.length}]),
      id: "pickup-1"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.adsDatas, (adv, idx) => {
          return (_openBlock(), _createElementBlock("div", { key: idx }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: getLogoOrImageSrc(adv.logo),
                  alt: "マイナビAGENT"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(adv.clientName), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: getLogoOrImageSrc(adv.image),
                  alt: ""
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("p", _hoisted_11, _toDisplayString(adv.compFeature), 1),
              _createElementVNode("a", {
                class: "p-recommend-button --type-1",
                href: adv.pickUpCLientUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: ($event: any) => (updateAdvertisementBrowsingFlag(adv.tgadContractId!))
              }, _hoisted_14, 8, _hoisted_12)
            ])
          ]))
        }), 128)),
        _hoisted_15
      ]),
      _hoisted_16
    ], 2)
  ]))
}
}

})